import * as Yup from 'yup'

import { NAME } from '../../../fields'
import { rightNameValidation } from '../../../validation'

export const validationSchema = Yup.object({
  [NAME]: rightNameValidation
})
